import { capitalize } from "../utils";

export function getItemHighlight(html, item, key, fallback = "N/A") {
  const highlighted = `${
    (item.highlights.find((h) => h["field"] === key) || {}).snippet ||
    item.document[key] ||
    fallback
  }&nbsp;`;
  return html`<highlight
    dangerouslySetInnerHTML=${{ __html: highlighted }}
  ></highlight>`;
}

export function space(html, times = 1) {
  const space = `&nbsp;`;
  return html`<highlight
    dangerouslySetInnerHTML=${{ __html: space.repeat(times) }}
  ></highlight>`;
}

export function getSecondaryHighlight(html, item, key) {
  const highlighted =
    item.highlights.find((h) => h["field"] === key) || item.highlights[0];
  let displayKey = highlighted.field.split(".");
  if (displayKey.length > 0) {
    displayKey = displayKey[1].replaceAll("_", " ");
  }
  const displayValue = highlighted.snippet;

  if (displayKey.includes("identifier")) {
    displayKey = "ID";
  }
  const parsed = `${capitalize(displayKey)}: ${displayValue}&nbsp;`;
  return html`<highlight
    dangerouslySetInnerHTML=${{ __html: parsed }}
  ></highlight>`;
}
